import React, { useEffect, useState } from 'react';
import { CreditCard } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '@/components/ui/switch';
import { bapi } from '@/lib/billingApi';

export const CardCheckoutSwitch = () => {
  const [on, setOn] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    bapi('/admin/billing/settings').then((s) => setOn(s.card_checkout_enabled !== false)).catch((e) => toast.error(e.message));
  }, []);

  const toggle = async (value) => {
    setBusy(true);
    try {
      const s = await bapi('/admin/billing/settings', { method: 'PUT', body: { card_checkout_enabled: value } });
      setOn(s.card_checkout_enabled);
      toast.success(value ? 'Card checkout is on' : 'Card checkout paused: customers now only see PayPal');
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const paused = on === false;
  return (
    <div className={`flex items-start justify-between gap-4 rounded-xl border p-4 transition-colors ${paused ? 'border-amber-300 bg-amber-50' : 'border-slate-200 bg-white'}`}
      data-testid="card-checkout-toggle-card">
      <div className="flex gap-3 min-w-0">
        <CreditCard className={`w-5 h-5 mt-0.5 shrink-0 ${paused ? 'text-amber-700' : 'text-[#00247D]'}`} />
        <div className="min-w-0">
          <p className="font-bold text-slate-900">Card checkout {on === null ? '' : paused ? 'paused' : 'on'}</p>
          <p className="text-sm text-slate-600" data-testid="card-checkout-status">
            {paused ? 'New card purchases, card updates and "Pay now" are hidden; customers only see PayPal. Automatic renewals, refunds and gateway checks keep working.'
              : "Customers can pay by Visa or Mastercard on the Plug'n Pay page."}
          </p>
        </div>
      </div>
      <Switch checked={!!on} disabled={on === null || busy} onCheckedChange={toggle} data-testid="card-checkout-switch" aria-label="Card checkout" />
    </div>
  );
};
